import { Component, OnInit } from '@angular/core';
import {CreadorService} from '../services/creador.service';
import {InicioFaces} from '../interfaces/inicioFaces';
import { HttpClient, HttpEventType } from '@angular/common/http';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { HttpHeaders } from '@angular/common/http';
import { AlertsService } from 'angular-alert-module';


@Component({
selector: 'app-creador',
templateUrl: './creador.component.html',
styleUrls: ['./creador.component.css']
})
export class CreadorComponent implements OnInit {
fileData: File = null;
        previewUrl:any = null;
        fileUploadProgress: string = null;
        uploadedFilePath: string = null;
uploadedFiles : Array<File>;
inicioAreas: InicioFaces[];
inicioEnlace: InicioFaces[];
inicioAlbum: InicioFaces[];
crearFrom: FormGroup;
tabActual = 1;
controlFroom: FormGroup;
asignarForm: FormGroup;
albumFrom: FormGroup;
crearA: any={};
controlArea: FormGroup;
submitted = false;
crea: any = {};
asigna: any = {};
enlace: any = {};
area: any = {};
busca: any = {};
ver: any = {};
aprobaModel: InicioFaces[];
buscarModel: InicioFaces[];
verModel: InicioFaces[];
verArea: any = {};
areaModel: InicioFaces[];
publicafrom: FormGroup;
crearP: any = {    contenido: "" };

constructor(private creadorService: CreadorService,private httpClient: HttpClient,private formBuilder: FormBuilder, private alerts: AlertsService) { }

onListarExtension() {
this.creadorService.buscarExtension(this.busca).subscribe((data: any) => {
this.buscarModel = data.obj;
return;
},
(error) => {
alert('Ocurrio un Error onListarExtension');
console.log("imprimir", error);
});
}

listarAprobacion() {
this.creadorService.mostrarAprobacion().subscribe((data: any) => {
this.aprobaModel = data.obj;
return;
},
(error) => {
alert('Ocurrio un Error listarAprobacion');
console.log("imprimir", error);
});
}

onBuscarEnlace() {
this.creadorService.buscarEnlace(this.ver).subscribe((data: any) => {
this.verModel = data.obj;
console.log("mendigo",data.obj);

return;
},
(error) => {
alert('Ocurrio un Error onListarEnlace');
console.log("imprimir", error);
});
}




listarAreas() {    
this.creadorService.mostrarAreas2().subscribe((data: any) => {
this.inicioAreas = data.obj;
return;
},
(error) => {
alert('Ocurrio un Error');
console.log("imprimir", error);
});
}


onEliminar(data){
if(confirm('¿ESTA SEGURO DE ELIMINAR LA EXTENSION?')){
this.creadorService.eliminarPropietarios(data).subscribe((data: any) => {
this.alerts.setMessage('ELIMINADO CORRECTAMENTE','warn');
this.onListarExtension();
return;
},
(error) => {
alert('Ocurrio un Error onBusquedad');
console.log("imprimir", error);
});    
};
}

onEliminarE(data){
if(confirm('¿ESTA SEGURO DE ELIMINAR EL ENLACE?')){
this.creadorService.eliminarEnlaces(data).subscribe((data: any) => {
this.alerts.setMessage('ENLACE ELIMINADO CORRECTAMENTE','warn');
this.onBuscarEnlace();
return;
},
(error) => {
alert('Ocurrio un Error onBusquedad');
console.log("imprimir", error);
});    
};
}


onApro(data){
if(confirm('¿ESTA SEGURO DE APROBAR EL ANUNCIO?')){
this.creadorService.aprobado(data).subscribe((data: any) => {
this.alerts.setMessage('ANUNCIO APROBADO CORRECTAMENTE','success');
return;
},
(error) => {
alert('Ocurrio un Error onApro');
console.log("imprimir", error);
});    
};
}

ondesApro(data){
if(confirm('¿ESTA SEGURO DE DESAPROBAR EL ANUNCIO?')){
this.creadorService.desAprobado(data).subscribe((data: any) => {
this.alerts.setMessage('ANUNCIO DESAPROBADO CORRECTAMENTE','success');
return;
},
(error) => {
alert('Ocurrio un Error onApro');
console.log("imprimir", error);
});    
};

}


onEliminarA(data){
    if(confirm('¿ESTA SEGURO DE ELIMINAR EL AREA?')){
    this.creadorService.eliminarArea(data).subscribe((data: any) => {
    this.alerts.setMessage('AREA ELIMINADA CORRECTAMENTE','success');
    this.listarAreas();
    return;
    },
    (error) => {
    alert('Ocurrio un Error onApro');
    console.log("imprimir", error);
    });    
    };
    }
/*
onApro2(data) {
this.creadorService.aprobado(data).subscribe((data : any) => {
this.alerts.setMessage('APROBADO','success');
console.log("imprimir", data);
});


return;
};*/


mostrarEnlace() {    
this.creadorService.listarEnlace().subscribe((data: any) => {
this.inicioEnlace = data.obj;

return;
},
(error) => {
alert('Ocurrio un Error');
console.log("imprimir", error);
});
}


onCrear() {
this.submitted = true;

if (this.crearFrom.valid) {
this.creadorService.almacenarPropietarios(this.crea).subscribe((data: any) => {
this.alerts.setMessage('EXTENSIÓN CREADA','success');
console.log("imprimir", data);
});

}else{
return;
}


}

onEnlace() {
this.submitted = true;

if (this.controlFroom.valid) {
this.creadorService.almacenarEnlace(this.enlace).subscribe((data) => {
this.alerts.setMessage('ENLACE CREADOO','success');
console.log("imprimir", data);
});

}else{
return;
}


}
onArea() {
    console.log('epaaaaa')
    this.submitted = true;
    
    if (this.controlArea.valid) {
    this.creadorService.crearArea(this.area).subscribe((data) => {
        //console.log("que pasa guacho",data);
    this.alerts.setMessage('AREA CREADA','success');
    //console.log("imprimir", data);
    return;
    });
    
    }else{
    return;
    }
    
    
    }

    onBuscarArea() {
        this.creadorService.buscarArea(this.verArea).subscribe((data: any) => {
           console.log("QUE COÑO",data);
        this.areaModel = data.obj;
        console.log("upale que cageu",this.areaModel);
        return;
        },
        (error) => {
        alert('Ocurrio un Error onBuscarArea');
        console.log("imprimir", error);
        });
        }




onDesPro(data){
if(confirm('¿ESTA SEGURO DE ELIMINAR LA PUBLICACIÓN?')){
this.creadorService.eliminarPropietarios(data).subscribe((data: any) => {
this.alerts.setMessage('PUBLICACION ELIMINADA CORRECTAMENTE','warn');
this.onListarExtension();
return;
},
(error) => {
alert('Ocurrio un Error onBusquedad');
console.log("imprimir", error);
});    
}
}
clear() {
    this.crearP = {};
    this.crearA = {};
}
validarcaracteres() {
    if (this.crearP.contenido.length >= 250) {
        return false;

    }
}

onPublicar() {
    console.log("hola que pasara mk ");
    this.submitted = true;

    const formData = new FormData();
    formData.append('file', this.fileData);
    formData.append('titulo', this.crearP.titulo);
    formData.append('contenido', this.crearP.contenido);


    this.fileUploadProgress = '0%';

    // stop the process here if form is invalid
    if (this.publicafrom.valid) {
        console.log("hola que pasara mk 2 ");
        this.creadorService.almacenPublicidad(formData, this.crearP).subscribe((data) => {
            console.log("hola que pasara mk 3");
            this.alerts.setMessage('PUBLICACIÒN ENTREGADA,Tu publicaciòn esta a la espera de aprobaciòn', 'success');
          
            this.clear();
        });

    } else {
        return;
    }

}

fileProgress(fileInput: any) {
    console.log('fileInput.target.files', fileInput.target.files);
    this.fileData = <File>fileInput.target.files;
    console.log('this.fileData', this.fileData);
    this.preview();
}

preview() {
  // Show preview
  var mimeType = this.fileData.type;
  if (mimeType.match(/image\/*/) == null) {
    return;
  }

  var reader = new FileReader();      
  reader.readAsDataURL(this.fileData);
  reader.onload = (_event) => {
    this.previewUrl = reader.result;
  }
}

onCrearAlbum() {
    console.log("hola que pasara CREEMEOOS**/*/*/*//8* ");
    this.submitted = true;

    const formData = new FormData();
    formData.append('file', this.fileData);
    formData.append('nombreAlbum', this.crearA.nombreAlbum);
    formData.append('descripcionAlbum', this.crearA.descripcionAlbum);


    this.fileUploadProgress = '0%';

    // stop the process here if form is invalid
    if (this.albumFrom.valid) {
        console.log("INGRESO A ALBUM778 ");
        this.creadorService.registraAlbum(formData, this.crearA).subscribe((data) => {
            console.log("INGRESO A ALBUM  3");
            this.alerts.setMessage('ALBUM CREADO', 'success');          
            this.clear();
        });

    } else {
        return;
        
    }

}

onAsociarFoto() {
    console.log("???????? ");
    this.submitted = true;

    const formData = new FormData();
    formData.append('file', this.fileData);
    formData.append('albumid', this.asigna.albumid);
    this.fileUploadProgress = '0%';
    console.log('hole',formData);
    // stop the process here if form is invalid
    if (this.asignarForm.valid) {
        console.log("hola que pasara  2/*/*/*//* ");
        this.creadorService.guardarFotos(formData, this.asigna).subscribe((data) => {
            console.log("hola que pasara  3",this.asigna);
            this.alerts.setMessage('FOTOS AGREGADAS CORRECTAMENTE AL ALBUM', 'success');

        });

    } else {
        return;
    }

}

listarAlbumes() {    
    this.creadorService.mostrarAlbumes().subscribe((data: any) => {
    this.inicioAlbum = data.obj;
    return;
    },
    (error) => {
    alert('Ocurrio un Error');
    console.log("imprimir", error);
    });
    }





    




ngOnInit() {
this.controlFroom = this.formBuilder.group({
opcion: ['', Validators.required],
name: ['', Validators.required],
url: ['', Validators.required],
});
this.controlArea = this.formBuilder.group({
    carea: ['', Validators.required]
    });
this.crearFrom = this.formBuilder.group({
areaid: ['', Validators.required],
nombreE: ['', Validators.required],
extension: ['', Validators.required],
});
this.asignarForm = this.formBuilder.group({
    albumid: ['', Validators.required],
    urlImage: ['', Validators.required],
    });
this.albumFrom = this.formBuilder.group({
    nombreAlbum: ['', Validators.required],
    descripcionAlbum: ['', Validators.required],
    urlA: ['', Validators.required],
     });
this.listarAreas();
this.mostrarEnlace();
this.listarAprobacion();
this.onBuscarArea();
this.listarAlbumes();
this.publicafrom = this.formBuilder.group({
    titulo: ['', Validators.required],
    contenido: ['', Validators.required],
    url: ['', Validators.required],

});
}

}
